// "Production" enabled environment

export const environment = {
  production: true,
  mSAzureClientId: "2afb1272-6af8-49d0-b4d3-8242d5ffc670",
  mSAzureAuthority:
    "https://login.microsoftonline.com/02ba0ed6-0443-4b34-b08b-0401cf16baec",
  homepageUrl: "https://sales.casper-electric.com/",
  authUrl: "https://usermanagerment.casper-electric.com/",
  authAPIUrl: "https://usermanagerment-api.casper-electric.com/user-service/api/",
  mdwAuthUrl: "https://mwi-auth.casper-electric.com/",
  mdwPortalUrl: "https://mwi-portal.casper-electric.com/",
  vietqrApiUrl: "https://api.vietqr.io/v2/business",
  hmr: false,
  appConfig: "appconfig.production.json",
    // Sentry Configuration
  sentry: {
    dsn: 'https://47bc3fe06342708519af344ac6b333f4@o4505792581140480.ingest.us.sentry.io/4510775869702144',
    environment: 'production',
    enabled: true
  }
};